import { render, staticRenderFns } from "./CorporationH.vue?vue&type=template&id=06deca15"
import script from "./CorporationH.vue?vue&type=script&lang=js"
export * from "./CorporationH.vue?vue&type=script&lang=js"
import style0 from "./CorporationH.vue?vue&type=style&index=0&id=06deca15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports